// extracted by mini-css-extract-plugin
export default {"whiteCard":"WhiteCard-modules__whiteCard__TUwM_","show-keyframe":"WhiteCard-modules__show-keyframe__nE97Y"};